import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { getLanguageFullName } from '@/helpers/language';

export function useLanguageSwitcher() {
  const store = useStore();
  const isModalOpen = ref(false);

  const uiLanguages = computed(() => store.getters['uiI18n/uiLanguages']);
  const locale = computed(() => store.getters['uiI18n/locale']);
  const showSwitcher = computed(() => uiLanguages.value.length > 1);
  const currentLanguageLabel = computed(() => getLanguageFullName(locale.value));

  const openModal = () => {
    isModalOpen.value = true;
  };

  return {
    isModalOpen,
    showSwitcher,
    currentLanguageLabel,
    openModal,
  };
}
